import Card from "@mui/material/Card";

import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";

import { isJobActive, SITE_LANGUAGES } from "./provider-site";
import type { ProviderSite } from "./site.documents";
import { useSetSiteLanguage } from "./site.hooks";
import { useSiteTranslations } from "./use-site-translations";

// The language the whole site renders in; a choice is saved at once and re-renders the site.
export function SiteLanguageCard({
  site,
  profileUuid,
  run,
}: {
  site: ProviderSite;
  profileUuid: string;
  run: (action: () => Promise<unknown>, errorTitle: string) => Promise<void>;
}) {
  const { t } = useSiteTranslations();
  const [setLanguage, { loading }] = useSetSiteLanguage();
  const disabled = loading || isJobActive(site.activeJob);

  return (
    <Card data-testid="provider-site-language">
      <SoftBox p={3} display="flex" flexDirection="column" gap={1.5}>
        <SoftTypography variant="caption" fontWeight="bold" color="text" textTransform="uppercase">
          {t.language.title}
        </SoftTypography>
        <SoftBox display="flex" flexWrap="wrap" gap={1}>
          {SITE_LANGUAGES.map((lang) => (
            <SoftButton
              key={lang}
              variant={site.lang === lang ? "gradient" : "outlined"}
              color="info"
              size="small"
              disabled={disabled}
              aria-pressed={site.lang === lang}
              onClick={() => {
                if (site.lang === lang) return;
                void run(
                  () => setLanguage({ variables: { profileUuid, lang } }),
                  t.errors.languageFailedTitle
                );
              }}
              data-testid={`provider-site-language-${lang}`}
            >
              {t.language.options[lang]}
            </SoftButton>
          ))}
        </SoftBox>
        <SoftTypography variant="caption" color="text">
          {t.language.hint}
        </SoftTypography>
      </SoftBox>
    </Card>
  );
}
